(function () {
  const mql = window.matchMedia('(max-width: 989px)');

  const qs = (root, sel) => (root ? root.querySelector(sel) : null);
  const qsa = (root, sel) => (root ? Array.from(root.querySelectorAll(sel)) : []);

  class PSBCH {
    constructor(root) {
      this.root = root;

      this.intervalMs = parseInt(root.getAttribute('data-interval') || '5000', 10);
      this.autoplay = (root.getAttribute('data-autoplay') || 'true') === 'true';

      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onDot = this.onDot.bind(this);
      this.onMediaChange = this.onMediaChange.bind(this);

      // ✅ swipe handlers bind
      this.onTouchStart = this.onTouchStart.bind(this);
      this.onTouchMove = this.onTouchMove.bind(this);
      this.onTouchEnd = this.onTouchEnd.bind(this);

      this.activeWrap = null;
      this.timer = null;

      // swipe state
      this.isDragging = false;
      this.startX = 0;
      this.startY = 0;
      this.deltaX = 0;
      this.lockedAxis = null; // 'x' | 'y' | null
      this.hadAutoplay = false;

      this.init();
      mql.addEventListener('change', this.onMediaChange);
    }

    destroy() {
      this.stop();
      mql.removeEventListener('change', this.onMediaChange);
      this.unbind();
      this.unbindSwipe();

      // ✅ 안전: 모바일 transform 잔존 제거
      if (this.track) this.track.style.transform = '';
    }

    onMediaChange() {
      this.stop();
      this.unbind();
      this.unbindSwipe();

      // ✅ 모드 전환 시 transform 잔존 제거
      if (this.track) this.track.style.transform = '';

      this.init();
    }

    getWrap() {
      return mql.matches ? qs(this.root, '.ps-bch__mobile') : qs(this.root, '.ps-bch__desktop');
    }

    init() {
      this.activeWrap = this.getWrap();
      if (!this.activeWrap) return;

      this.slider = qs(this.activeWrap, '.ps-bch__slider');
      this.track = qs(this.activeWrap, '[data-ps-bch-track]');
      this.slides = qsa(this.activeWrap, '[data-ps-bch-slide]');
      this.prevBtn = qs(this.activeWrap, '[data-ps-bch-prev]');
      this.nextBtn = qs(this.activeWrap, '[data-ps-bch-next]');
      this.dotsWrap = qs(this.activeWrap, '[data-ps-bch-dots]');
      this.dots = this.dotsWrap ? qsa(this.dotsWrap, '[data-ps-bch-dot]') : [];

      if (!this.track || !this.slides.length) return;

      // ✅ 데스크탑 진입 시 transform 강제 초기화
      if (!mql.matches) this.track.style.transform = '';

      this.index = this.slides.findIndex((el) => el.classList.contains('is-active'));
      if (this.index < 0) this.index = 0;

      // 초기 상태
      this.go(this.index);

      this.bind();
      this.bindSwipe();

      if (this.autoplay && this.slides.length > 1) this.start();
    }

    bind() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
      if (this.dots && this.dots.length) this.dots.forEach((btn) => btn.addEventListener('click', this.onDot));
    }

    unbind() {
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
      if (this.dots && this.dots.length) this.dots.forEach((btn) => btn.removeEventListener('click', this.onDot));
    }

    // ✅ 모바일 스와이프 바인딩
    bindSwipe() {
      if (!mql.matches) return; // 모바일만
      if (!this.slider || !this.track || this.slides.length <= 1) return;

      // iOS 사파리에서 수평 스와이프 인식 개선
      // (CSS에서도 touch-action: pan-y; 주면 더 좋음)
      this.slider.addEventListener('touchstart', this.onTouchStart, { passive: true });
      this.slider.addEventListener('touchmove', this.onTouchMove, { passive: false }); // preventDefault 필요
      this.slider.addEventListener('touchend', this.onTouchEnd, { passive: true });
      this.slider.addEventListener('touchcancel', this.onTouchEnd, { passive: true });
    }

    unbindSwipe() {
      if (!this.slider) return;
      this.slider.removeEventListener('touchstart', this.onTouchStart);
      this.slider.removeEventListener('touchmove', this.onTouchMove);
      this.slider.removeEventListener('touchend', this.onTouchEnd);
      this.slider.removeEventListener('touchcancel', this.onTouchEnd);
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.go((this.index + 1) % this.slides.length), this.intervalMs);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    onPrev() {
      this.stop();
      this.go(this.index === 0 ? this.slides.length - 1 : this.index - 1);
      if (this.autoplay) this.start();
    }

    onNext() {
      this.stop();
      this.go((this.index + 1) % this.slides.length);
      if (this.autoplay) this.start();
    }

    onDot(e) {
      const idx = parseInt(e.currentTarget.getAttribute('data-ps-bch-dot') || '0', 10);
      if (!Number.isFinite(idx)) return;
      this.stop();
      this.go(idx);
      if (this.autoplay) this.start();
    }

    // ---------- ✅ Swipe logic ----------
    onTouchStart(e) {
      if (!mql.matches) return;
      if (!e.touches || e.touches.length !== 1) return;

      const t = e.touches[0];
      this.isDragging = true;
      this.lockedAxis = null;
      this.startX = t.clientX;
      this.startY = t.clientY;
      this.deltaX = 0;

      // autoplay 잠시 중단
      this.hadAutoplay = !!this.timer;
      this.stop();
    }

    onTouchMove(e) {
      if (!this.isDragging) return;
      if (!mql.matches) return;
      if (!e.touches || e.touches.length !== 1) return;

      const t = e.touches[0];
      const dx = t.clientX - this.startX;
      const dy = t.clientY - this.startY;

      // 처음 몇 px에서 축 고정
      if (!this.lockedAxis) {
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
          this.lockedAxis = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
        } else {
          return;
        }
      }

      // 세로 스크롤 의도면 그냥 놔둠
      if (this.lockedAxis === 'y') return;

      // 수평 스와이프 의도면 스크롤 방지
      e.preventDefault();

      this.deltaX = dx;

      // 드래그 중에는 현재 index 기준으로 translateX를 px로 보정
      const base = -(this.index * 100);
      // track이 %로 움직이므로 px 보정은 slider 폭 기준으로 %로 환산
      const w = this.slider ? this.slider.clientWidth : 0;
      const dragPercent = w ? (dx / w) * 100 : 0;

      this.track.style.transform = `translateX(${base + dragPercent}%)`;
    }

    onTouchEnd() {
      if (!this.isDragging) return;

      const dx = this.deltaX;
      this.isDragging = false;
      this.lockedAxis = null;

      // 임계값: px 기준
      const threshold = 40;

      if (Math.abs(dx) >= threshold) {
        if (dx > 0) {
          // 오른쪽으로 드래그 => 이전
          this.go(this.index === 0 ? this.slides.length - 1 : this.index - 1);
        } else {
          // 왼쪽으로 드래그 => 다음
          this.go((this.index + 1) % this.slides.length);
        }
      } else {
        // 스냅백
        this.go(this.index);
      }

      // autoplay 재개
      if (this.autoplay && this.slides.length > 1) this.start();
    }

    // ---------- core go ----------
    go(nextIndex) {
      const isMobile = mql.matches;

      if (isMobile) {
        const x = -(nextIndex * 100);
        this.track.style.transform = `translateX(${x}%)`;
      } else {
        this.track.style.transform = '';
      }

      this.slides.forEach((el, i) => {
        const active = i === nextIndex;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      if (this.dots && this.dots.length) {
        this.dots.forEach((btn, i) => {
          const active = i === nextIndex;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      this.index = nextIndex;
    }
  }

  function boot() {
    const roots = document.querySelectorAll('[data-ps-bch]');
    roots.forEach((root) => {
      if (root.__psBCH) return;
      root.__psBCH = new PSBCH(root);
    });
  }

  function teardown(e) {
    const section = e && e.target ? e.target : null;
    if (!section) return;
    const root = section.querySelector('[data-ps-bch]');
    if (root && root.__psBCH) {
      root.__psBCH.destroy();
      delete root.__psBCH;
    }
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', teardown);
})();